import DefaultLayout from "@/layouts/DefaultLayout.vue"; // Import DefaultLayout

import FAQPage from "../views/ChinaUs/FAQPage.vue";
import CompetitionDetailsPage from "../views/ChinaUs/CompetitionDetailsPage.vue";
import DiscussionPage from "../views/ChinaUs/DiscussionPage.vue";
import DiscussionDetailsPage from "../views/ChinaUs/DiscussionDetailsPage.vue";
import SubmissionPage from "../views/ChinaUs/SubmissionPage.vue";
import SubmissionSubmitPage from "../views/ChinaUs/SubmissionSubmitPage.vue";
import SubmissionListPage from "../views/ChinaUs/SubmissionListPage.vue";
import SubmissionDetailPage from "../views/ChinaUs/SubmissionDetailPage.vue";
import SubmissionReviewPage from "../views/ChinaUs/SubmissionReviewPage.vue";

const chinaUsRoutes = [
  {
    path: "/china-us",
    component: DefaultLayout,
    meta: { requiresAuth: false },
    children: [
      {
        path: "faq",
        name: "ChinaUSFAQPage",
        component: FAQPage,
        meta: { requiresAuth: false, title: "FAQ" },
      },
      {
        path: "competition-details",
        name: "CompetitionDetailsPage",
        component: CompetitionDetailsPage,
        meta: { requiresAuth: false, title: "Competition Details" },
      },
      {
        path: "discussion",
        name: "DiscussionPage",
        component: DiscussionPage,
        meta: { requiresAuth: true, title: "Discussion" },
      },
      {
        path: "discussion/:id",
        name: "DiscussionDetailsPage",
        component: DiscussionDetailsPage,
        meta: { requiresAuth: true, title: "Discussion Details" },
      },
      {
        path: "submission",
        name: "SubmissionPage",
        component: SubmissionPage,
        meta: { requiresAuth: false, title: "Submission" },
      },
      {
        path: "submission-submit",
        name: "SubmissionSubmitPage",
        component: SubmissionSubmitPage,
        meta: { requiresAuth: true, title: "Submit Submission" },
      },
      {
        path: "submission-list",
        name: "SubmissionListPage",
        component: SubmissionListPage,
        meta: { requiresAuth: false, title: "Submission List" },
      },
      {
        path: "submission-detail/:id",
        name: "SubmissionDetailPage",
        component: SubmissionDetailPage,
        meta: { requiresAuth: false, title: "Submission Detail" },
      },
      {
        path: "submission-review/:id",
        name: "SubmissionReviewPage",
        component: SubmissionReviewPage,
        meta: { requiresAuth: false, title: "Submission Review" },
      },
    ],
  },
];

export default chinaUsRoutes;
